const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 5154",
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.481,
    height: 94.986,
    viewBox: "0 0 81.481 94.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5155"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13825",
    d: "M16.015 90.523c0 3.279-4.981 3.279-4.981 0v-49.64H-8.51a2.491 2.491 0 0 1-2.49-2.49V10.571A2.491 2.491 0 0 1-8.51 8.08h19.544V.455c0-3.279 4.981-3.279 4.981 0V8.08h44.749a2.491 2.491 0 0 1 2.244 1.409L70.123 23.2a2.479 2.479 0 0 1-.024 2.608l-7.215 13.869a2.477 2.477 0 0 1-2.121 1.2v.011H16.015zm43.361-77.462h-65.4V35.9h65.4L65.1 24.482z",
    transform: "translate(11 2.004)",
    style: {
      fill: "#313280"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnd);
export default __webpack_public_path__ + "static/media/end.80fb65c686ce4ba19c2a97e4da528d6d.svg";
export { ForwardRef as ReactComponent };